import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import HeroSection from '../components/RealEsatePostcards/HeroSection'
import OurServices from '../components/RealEsatePostcards/OurServices'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import RealEstateCompetitors from '../components/RealEsatePostcards/RealEstateCompetitors'
import InvestorsSay from '../components/RealEsatePostcards/InvestorsSay'
import HowItWorks from '../components/RealEsatePostcards/HowItWorks'
import RealEstateFAQs from '../components/RealEsatePostcards/RealEstateFAQs'
import ReadyToElevateCta from '../components/RealEsatePostcards/ReadyToElevateCta'
import FreeCallKeySection from '../components/RealEsatePostcards/FreeCallKeySection'
import ProductCards from '../components/RealEsatePostcards/ProductCards'

export default function RealEstatePostcards({ data, products }) {
    return (
        <LandingPageWrapper>
            <Header meta={data?.yoast_head} />
            <HeroSection />
            <OurServices />
            <RealEstateCompetitors />
            <ProductCards products={products} />
            <InvestorsSay />
            <HowItWorks />
            <FreeCallKeySection />
            <RealEstateFAQs />
            <ReadyToElevateCta />
        </LandingPageWrapper>
    )
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {
    // const data = { } //await GeneralAPI.getFrontPage()

    const page = await GeneralAPI.getPageBySlug('/real-estate-postcards')
    const data = page ? page[0] : {}

    const products = await GeneralAPI.getACFProductsPage()
    const { banners } = await GeneralAPI.getACFBanners()
    data.banners = banners

    return {
        props: {
            data,
            products,
            hideTopNav: true,
            hideCartButton: true,
            hideLoginButton: true,
        },
        revalidate: 10, // In seconds
    }
}
